var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBasicPlanIcon = function SvgBasicPlanIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83317 1.16666H1.74984C1.42767 1.16666 1.1665 1.42782 1.1665 1.74999V5.83332C1.1665 6.15549 1.42767 6.41666 1.74984 6.41666H5.83317C6.15534 6.41666 6.4165 6.15549 6.4165 5.83332V1.74999C6.4165 1.42782 6.15534 1.16666 5.83317 1.16666Z",
    fill: "#5656FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83317 7.58334H1.74984C1.42767 7.58334 1.1665 7.84451 1.1665 8.16668V12.25C1.1665 12.5722 1.42767 12.8333 1.74984 12.8333H5.83317C6.15534 12.8333 6.4165 12.5722 6.4165 12.25V8.16668C6.4165 7.84451 6.15534 7.58334 5.83317 7.58334Z",
    fill: "#D5D5FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2502 1.16666H8.16683C7.84466 1.16666 7.5835 1.42782 7.5835 1.74999V5.83332C7.5835 6.15549 7.84466 6.41666 8.16683 6.41666H12.2502C12.5723 6.41666 12.8335 6.15549 12.8335 5.83332V1.74999C12.8335 1.42782 12.5723 1.16666 12.2502 1.16666Z",
    fill: "#D5D5FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2502 7.58334H8.16683C7.84466 7.58334 7.5835 7.84451 7.5835 8.16668V12.25C7.5835 12.5722 7.84466 12.8333 8.16683 12.8333H12.2502C12.5723 12.8333 12.8335 12.5722 12.8335 12.25V8.16668C12.8335 7.84451 12.5723 7.58334 12.2502 7.58334Z",
    fill: "#D5D5FB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBasicPlanIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/basicPlanIcon.538108c1.svg";
export { ForwardRef as ReactComponent };